import React, { useState, useEffect } from "react"
import { ThemeProvider } from "@material-ui/core"

import { renderComponent, unmountComponent } from "@/utils/node"
import { usePermissionStateStore } from "@/store/PermissionState"
import ReferralService from "@/services/ReferralService"
import ReferralPopup from "@/pages/Attendance/ReferralPopup"
import theme from "@/styles/theme"

const TRIGGER_ID = "referral-popup-trigger"

type ReferralPopupTriggerType = {
	open: () => void
}

const ReferralPopupTriggerContent: React.FC = () => {
	const { checkPermission } = usePermissionStateStore()
	const isAdmin = checkPermission("manager-panel", "access")

	const [referralLink, setReferralLink] = useState<string>("")
	const [opened, setOpened] = useState<boolean>(true)

	useEffect(() => {
		const fetchReferralLink = async () => {
			try {
				const response = await ReferralService.getIndicationLink()
				setReferralLink(response.link)
			} catch {
				setReferralLink("")
			}
		}
		fetchReferralLink()
	}, [])

	const handleClose = () => {
		setOpened(false)
		unmountComponent(TRIGGER_ID)
	}

	return (
		<ThemeProvider theme={theme}>
			<ReferralPopup
				open={opened}
				isAdmin={isAdmin}
				referralLink={referralLink}
				onClose={handleClose}
			/>
		</ThemeProvider>
	)
}

const ReferralPopupTrigger: ReferralPopupTriggerType = {
	open: () => {
		renderComponent(TRIGGER_ID, <ReferralPopupTriggerContent />)
	}
}

export default ReferralPopupTrigger
